(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93625],{

/***/ 659012:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/landing/[id]",
      function () {
        return __webpack_require__(359190);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 359190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ landing_id_; }
});

// EXTERNAL MODULE: ./components/desktop/pages/Landing.tsx
var Landing = __webpack_require__(759135);
;// CONCATENATED MODULE: ./tenants/_template/desktop/landing/[id].tsx

/* harmony default export */ var _id_ = (Landing/* LandingPage */.f);

;// CONCATENATED MODULE: ./pages/default/desktop/landing/[id].tsx
// AUTO GENERATED FILE. DO NOT EDIT.

/* harmony default export */ var landing_id_ = (_id_);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41305,90400,29078,9125,88837,22859,48530,93712,49774,92888,40179], function() { return __webpack_exec__(659012); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);